
import { Button, Modal } from "react-bootstrap";
import { useContext, useState } from "react";
import { LicenseEntry, LicenseType, getAPIroot } from "../../../../collector";
import { Utils } from "../../../../utils";
import { ErrorContext } from "../../../../context/ErrorContext";
import { AuthContext } from "../../../../context/AuthContext";
import Switch from "../../../../components/Switch/Switch";

interface CreateLicenseProps {
    createdLicense: () => void;
}

export default function CreateLicenseModal(props: CreateLicenseProps) {

    const [show, setShow] = useState<boolean>(false)
    const [license, setLicense] = useState<LicenseEntry>({
        licensed_to: "",
        name: "",
        key: "", //Should be auto-generated
        issue_date: Date.now(),
        start_date: Date.now(),
        expire_date: new Date().setFullYear(new Date().getFullYear() + 1),
        persistent_license: true,
        revoked: false,
        device_limit: 4,
        devices: [],
        license_type: LicenseType.Pro,
    });
    const { showErrorModal } = useContext(ErrorContext);
    const { token } = useContext(AuthContext);

    const handleClose = () => setShow(false);
    const handleShow = () => {
        setLicense({
            licensed_to: "",
            name: "",
            key: "",
            issue_date: Date.now(),
            start_date: Date.now(),
            expire_date: new Date().setFullYear(new Date().getFullYear() + 1),
            persistent_license: true,
            revoked: false,
            device_limit: 4,
            devices: [],
            license_type: LicenseType.Pro
        });
        setShow(true)
    };

    const createLicense = async () => {
        try {
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer' + token(),
                },
                body: JSON.stringify({
                    'userID': license.licensed_to,
                    'name': license.name,
                    'affiliation': license.affiliation,
                    'persistentLicense': license.persistent_license,
                    'startDate': license.start_date,
                    'endDate': license.expire_date,
                    'deviceLimit': license.device_limit,
                    'licenseType': license.license_type,
                })
            }
            await fetch(getAPIroot() + 'issue_key', requestOptions)
                .then((res) => {
                    if (!res.ok) {
                        throw Error;
                    }
                    return res.json();
                })
                .then(() => {
                    props.createdLicense();
                    handleClose();
                });
        } catch (error) {
            showErrorModal("Failed to create license - Server is unavailable at the moment");
            console.error(error)
        }
    }

    return (
        <>
            <Button variant='outline-dark' onClick={() => handleShow()}>
                Create License
            </Button>
            <Modal
                show={show}
                backdrop="static"
                onHide={() => handleClose()}
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Create License</Modal.Title>
                </Modal.Header>
                <form
                    onSubmit={(e) => {
                        e.preventDefault();
                        createLicense();
                    }}
                >
                    <Modal.Body>
                        <div className="dialog-data-field">
                            <span>License Type:</span>
                            <select value={license.license_type} required onChange={(item) => { setLicense({ ...license, license_type: Number(item.target.value) }) }}>
                                <option value={LicenseType.Pro}>DOTE Pro</option>
                                <option value={LicenseType.ProCommunity}>DOTE Pro Community</option>
                                <option value={LicenseType.AAU}>DOTE AAU</option>
                                <option value={LicenseType.SiteLicense}>Site-License</option>
                            </select>
                        </div>
                        <div className="dialog-data-field">
                            <span>User ID:</span>
                            <input type="email" placeholder="Write User ID here..." value={license.licensed_to} required
                                onChange={(item) => setLicense({ ...license, licensed_to: item.target.value })}
                            />
                        </div>
                        <div className="dialog-data-field">
                            <span>Name:</span>
                            <input type="text" placeholder="Write Name here..." value={license.name} required
                                onChange={(item) => setLicense({ ...license, name: item.target.value })}
                            />
                        </div>
                        <div className="dialog-data-field">
                            <span>Affiliation:</span>
                            <input type="text" placeholder="Write Affiliation here..." value={license.affiliation ?? ""}
                                onChange={(item) => setLicense({ ...license, affiliation: item.target.value })}
                            />
                        </div>
                        <div className="dialog-data-field">
                            <span>Issue Date:</span>
                            <span>{new Date(Date.now()).toLocaleString()}</span>
                        </div>
                        <div className="dialog-data-field">
                            <span>Start Date:</span>
                            <input
                                type="date"
                                value={Utils.dateToValidString(new Date(license.start_date))}
                                required
                                onChange={(item) => {
                                    let currVal = new Date(item.target.value).getTime();
                                    if (currVal > license.expire_date) {
                                        setLicense({ ...license, expire_date: currVal })
                                    }
                                    setLicense({ ...license, start_date: new Date(item.target.value).getTime() })
                                }}
                            />
                        </div>
                        <div className="dialog-data-field">
                            <span>Expiry Date:</span>
                            <input
                                type="date"
                                value={Utils.dateToValidString(new Date(license.expire_date))}
                                min={Utils.dateToValidString(new Date(license.start_date))}
                                required
                                onChange={(item) => setLicense({ ...license, expire_date: new Date(item.target.value).getTime() })}
                            />
                        </div>
                        <div className="dialog-data-field">
                            <span>Persistent License:</span>
                            <Switch checked={license.persistent_license} onChange={(item) => setLicense({ ...license, persistent_license: item.target.checked })} />
                        </div>
                        <div className="dialog-data-field">
                            <span>Device Limit:</span>
                            <input
                                type="number"
                                value={license.device_limit}
                                min={1}
                                onChange={(val) => {
                                    if (Number(val.currentTarget.value) < Number(val.currentTarget.min)) {
                                        val.currentTarget.value = val.currentTarget.min;
                                    }
                                    setLicense({ ...license, device_limit: Number(val.target.value) });
                                }}
                            />
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => handleClose()}>
                            Close
                        </Button>
                        <Button variant="primary" type='submit'>Create License</Button>
                    </Modal.Footer>
                </form>
            </Modal>
        </>
    );
}
